import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const ShelfStatusIcon = ({ className = 'default' }: Props) => <div className={classNames('status', 'icon-checkmark', className)} />;

export default ShelfStatusIcon;
